import AjaxClass from '@/ajax'

export default class AttestationInfoService {
  ajax

  constructor (store) {
    this.ajax = new AjaxClass(store)
  }

  static getDefaultAttestations () {
    return {
      yesterday: [],
      today: [],
      tomorrow: []
    }
  }

  static getDefaultAttestationInfo () {
    return {
      group: {
        attestationInfo: {},
        students: []
      },
      counter: {
        yesterday: [],
        today: [],
        tomorrow: []
      }
    }
  }

  getAttestationInfoList (then) {
    return this.ajax.get('/attestation_info', {}, (data) => {
      return then(data)
    })
  }

  getAttestationInfo (groupId, then) {
    return this.ajax.get('/attestation_info/' + groupId, {}, (data) => {
      return then(data)
    })
  }
}



// WEBPACK FOOTER //
// ./src/services/AttestationInfoService.js